import React, { useEffect, useState } from "react";
import "./Confirmation.css";
import { BASE_URL } from "../../helpers/api";

export default function ConfirmationPage({ amount }) {
  const [appointment, setAppointment] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAppointment = async () => {
      const appointmentId = localStorage.getItem("appointment_id");
      if (!appointmentId) {
        setLoading(false);
        return;
      }
      try {
        const res = await fetch(`${BASE_URL}/appointments/${appointmentId}`);
        const data = await res.json();
        setAppointment(data);
      } catch (err) {
        console.error("Error fetching appointment:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAppointment();
  }, []);

  if (loading) {
    return <p>Loading confirmation...</p>;
  }

  if (!appointment) {
    return <p>No appointment details found.</p>;
  }

  return (
    <div className="confirmation-container">
      <h2>Thank You For Booking Appointment Slot</h2>
      <button className="pay-now-btn">PAY NOW</button>
      <p className="secure-note">✅ 100% SECURE PAYMENT</p>

      <div className="booking-details">
        <h3>Appointment Slot Booking Details</h3>

        {/* Patient */}
        <div className="detail-card">
          <h3>Patient Details</h3>
          <p><strong>Name:</strong> {appointment?.patient?.name || "N/A"}</p>
          <p><strong>Email:</strong> {appointment?.patient?.email || "N/A"}</p>
          <p><strong>Phone:</strong> {appointment?.patient?.phone || "N/A"}</p>
          <p><strong>Date:</strong> {appointment?.date || "N/A"}</p>
          <p><strong>Time:</strong> {appointment?.time_slot || "N/A"}</p>
          <p><strong>Location:</strong> {appointment?.location?.name || "N/A"}</p>
          <p><strong>Reason:</strong> {appointment?.problem || "N/A"}</p>
        </div>

        {/* Doctor */}
        <div className="detail-card">
          <h3>Doctor Details</h3>
          <p><strong>Doctor:</strong> {appointment?.doctor?.name || "N/A"}</p>
          <p><strong>Specialty:</strong> {appointment?.doctor?.specialty || "N/A"}</p>
        </div>

        {/* Payment */}
        <div className="detail-card">
          <h3>Payment Details</h3>
          <p><strong>Payment Status:</strong> Pay at Hospital</p>
          <p><strong>Amount Payable:</strong> ₹{amount}</p>
        </div>
      </div>
    </div>
  );
}